export enum OrderDetailsGridType {
    orderLineItemsEditable = 'orderLineItemsEditable',
    orderLineItemsReadonly = 'orderLineItemsReadonly',
    orderFinancialSummary = 'orderFinancialSummary',
    orderHistoryLogs = 'orderHistoryLogs',
}
